import React, { useEffect, useState } from 'react';
import {
    deliveryHeadCellStyle,
    deliveryMainCellStyle,
    deliverySpotsContainerStyle,
    deliverySpotsHeadCellStyle,
    deliverySumCellStyle,
    deliveryTextStyle,
    deliveryTotalCellStyle,
    spotsTableStyle
} from '../AirtimePlanningStyles';
import { digitFormat, addDays } from '../AirtimePlanningUtils';

const DeliverySpots = ({ planSummary, hasPlan }) => {
    const [tableData, setTableData] = useState({});
    const [rowTotals, setRowTotals] = useState({});
    const [colTotals, setColTotals] = useState({});
    const [totalSpots, setTotalSpots] = useState(0);
    const [rowIndexes, setRowIndexes] = useState([]);

    const calculateTableData = () => {
        const newData = {};
        const newRowTotals = {};
        const newColTotals = {};
        const rIndexes = [];
        let newTotal = 0;
        for (let i = 0; i < planSummary?.length; i++) {
            if (!rIndexes.includes(planSummary[i]?.dayPartName))
                rIndexes.push(planSummary[i]?.dayPartName);
            const iDay = addDays(planSummary[i]?.orderedDate, 0)?.getDay();
            if (iDay >= 0) {
                if (!newData[planSummary[i]?.dayPartName])
                    newData[planSummary[i]?.dayPartName] = {};
                if (!newData[planSummary[i]?.dayPartName][iDay])
                    newData[planSummary[i]?.dayPartName][iDay] = 0;
                newData[planSummary[i]?.dayPartName][iDay] +=
                    planSummary[i]?.spotCount;

                if (!newRowTotals[planSummary[i]?.dayPartName])
                    newRowTotals[planSummary[i]?.dayPartName] = 0;
                newRowTotals[planSummary[i]?.dayPartName] +=
                    planSummary[i]?.spotCount;

                if (!newColTotals[iDay]) newColTotals[iDay] = 0;
                newColTotals[iDay] += planSummary[i]?.spotCount;

                newTotal += planSummary[i]?.spotCount;
            }
        }

        setTableData(newData);
        setRowTotals(newRowTotals);
        setColTotals(newColTotals);
        setRowIndexes(rIndexes.sort());
        setTotalSpots(newTotal);
    };

    const blankTableData = () => {
        const newData = {};
        for (let i = 0; i < 6; i++) {
            newData[i] = '';
        }
        setTableData(newData);
    };

    useEffect(() => {
        if (planSummary && hasPlan) {
            calculateTableData();
        } else {
            blankTableData();
        }
    }, [planSummary, hasPlan]);

    const tableDataByCell = (rowIndex, colIndex) => {
        return !hasPlan
            ? ''
            : digitFormat(tableData[rowIndexes[rowIndex]]?.[colIndex]) || '00';
    };

    return (
        <div style={deliverySpotsContainerStyle}>
            <table style={spotsTableStyle}>
                <thead>
                    <tr>
                        <th>{window.translate('Total Spots')}</th>

                        <th colSpan='9' style={{...deliveryHeadCellStyle, height:40}}>
                            {window.translate('Spots')}
                        </th>
                    </tr>

                    <tr>
                        <th style={{...deliverySpotsHeadCellStyle,width:'8.28%'}}>
                            <span style={deliveryTextStyle}>
                                {!hasPlan ? '' : window.translate('Daypart')}
                            </span>
                        </th>

                        <th style={deliverySpotsHeadCellStyle}>
                            <span style={deliveryTextStyle}>
                                {!hasPlan ? '' : window.translate('Mon')}
                            </span>
                        </th>

                        <th style={deliverySpotsHeadCellStyle}>
                            <span style={deliveryTextStyle}>
                                {!hasPlan ? '' : window.translate('Tue')}
                            </span>
                        </th>

                        <th style={deliverySpotsHeadCellStyle}>
                            <span style={deliveryTextStyle}>
                                {!hasPlan ? '' : window.translate('Wed')}
                            </span>
                        </th>

                        <th style={deliverySpotsHeadCellStyle}>
                            <span style={deliveryTextStyle}>
                                {!hasPlan ? '' : window.translate('Thu')}
                            </span>
                        </th>

                        <th style={deliverySpotsHeadCellStyle}>
                            <span style={deliveryTextStyle}>
                                {!hasPlan ? '' : window.translate('Fri')}
                            </span>
                        </th>

                        <th style={deliverySpotsHeadCellStyle}>
                            <span style={deliveryTextStyle}>
                                {!hasPlan ? '' : window.translate('Sat')}
                            </span>
                        </th>

                        <th style={deliverySpotsHeadCellStyle}>
                            <span style={deliveryTextStyle}>
                                {!hasPlan ? '' : window.translate('Sun')}
                            </span>
                        </th>

                        <th style={deliverySpotsHeadCellStyle}>
                            <span style={deliveryTextStyle}>
                                {!hasPlan
                                    ? ''
                                    : window.translate('Spots Total')}
                            </span>
                        </th>

                        <th style={{...deliverySpotsHeadCellStyle, width:'6.28%'}}>
                            <span style={deliveryTextStyle}>
                                {!hasPlan
                                    ? ''
                                    : window.translate('Spots Total %')}
                            </span>
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {Object.keys(tableData)?.map((dp, i) => {
                        return (
                            <tr key={`daypart${i}-spots`}>
                                <td
                                    style={{
                                        ...deliveryMainCellStyle(i),
                                        paddingLeft: 19.5,
                                        width: 478
                                    }}
                                >
                                    <span style={deliveryTextStyle}>
                                        {!hasPlan ? '' : rowIndexes[i] ?? ''}
                                    </span>
                                </td>
                                <td
                                    align='right'
                                    style={deliveryMainCellStyle(i)}
                                >
                                    <span style={deliveryTextStyle}>
                                        {tableDataByCell(i, 1)}
                                    </span>
                                </td>
                                <td
                                    align='right'
                                    style={deliveryMainCellStyle(i)}
                                >
                                    <span style={deliveryTextStyle}>
                                        {tableDataByCell(i, 2)}
                                    </span>
                                </td>
                                <td
                                    align='right'
                                    style={deliveryMainCellStyle(i)}
                                >
                                    <span style={deliveryTextStyle}>
                                        {tableDataByCell(i, 3)}
                                    </span>
                                </td>
                                <td
                                    align='right'
                                    style={deliveryMainCellStyle(i)}
                                >
                                    <span style={deliveryTextStyle}>
                                        {tableDataByCell(i, 4)}
                                    </span>
                                </td>
                                <td
                                    align='right'
                                    style={deliveryMainCellStyle(i)}
                                >
                                    <span style={deliveryTextStyle}>
                                        {tableDataByCell(i, 5)}
                                    </span>
                                </td>
                                <td
                                    align='right'
                                    style={deliveryMainCellStyle(i)}
                                >
                                    <span style={deliveryTextStyle}>
                                        {tableDataByCell(i, 6)}
                                    </span>
                                </td>
                                <td
                                    align='right'
                                    style={deliveryMainCellStyle(i)}
                                >
                                    <span style={deliveryTextStyle}>
                                        {tableDataByCell(i, 0)}
                                    </span>
                                </td>
                                <td
                                    align='right'
                                    style={deliveryTotalCellStyle(i)}
                                >
                                    <span style={deliveryTextStyle}>
                                        {!hasPlan
                                            ? ''
                                            : digitFormat(
                                                rowTotals[rowIndexes[i]] ?? 0
                                            ) || '00'}
                                    </span>
                                </td>
                                <td
                                    align='right'
                                    style={deliveryTotalCellStyle(i)}
                                >
                                    <span style={deliveryTextStyle}>
                                        {!hasPlan
                                            ? ''
                                            :  digitFormat(Math.round(((rowTotals[rowIndexes[i]])/totalSpots)*100) ?? 0
                                            ) || '00'
                                        }
                                    </span>
                                </td>
                            </tr>
                        );
                    })}
                    <tr>
                        <td
                            style={{
                                ...deliverySumCellStyle,
                                paddingLeft: 19.5,
                                width: 478
                            }}
                        >
                            <span style={deliveryTextStyle}>
                                {!hasPlan ? '' : 'Total'}
                            </span>
                        </td>
                        <td align='right' style={deliverySumCellStyle}>
                            <span style={deliveryTextStyle}>
                                {!hasPlan
                                    ? ''
                                    : digitFormat(colTotals[1] ?? 0) || '00'}
                            </span>
                        </td>
                        <td align='right' style={deliverySumCellStyle}>
                            <span style={deliveryTextStyle}>
                                {!hasPlan
                                    ? ''
                                    : digitFormat(colTotals[2] ?? 0) || '00'}
                            </span>
                        </td>
                        <td align='right' style={deliverySumCellStyle}>
                            <span style={deliveryTextStyle}>
                                {!hasPlan
                                    ? ''
                                    : digitFormat(colTotals[3] ?? 0) || '00'}
                            </span>
                        </td>
                        <td align='right' style={deliverySumCellStyle}>
                            <span style={deliveryTextStyle}>
                                {!hasPlan
                                    ? ''
                                    : digitFormat(colTotals[4] ?? 0) || '00'}
                            </span>
                        </td>
                        <td align='right' style={deliverySumCellStyle}>
                            <span style={deliveryTextStyle}>
                                {!hasPlan
                                    ? ''
                                    : digitFormat(colTotals[5] ?? 0) || '00'}
                            </span>
                        </td>
                        <td align='right' style={deliverySumCellStyle}>
                            <span style={deliveryTextStyle}>
                                {!hasPlan
                                    ? ''
                                    : digitFormat(colTotals[6] ?? 0) || '00'}
                            </span>
                        </td>
                        <td align='right' style={deliverySumCellStyle}>
                            <span style={deliveryTextStyle}>
                                {!hasPlan
                                    ? ''
                                    : digitFormat(colTotals[0] ?? 0) || '00'}
                            </span>
                        </td>
                        <td align='right' style={deliverySumCellStyle}>
                            <span style={deliveryTextStyle}>
                                {!hasPlan
                                    ? ''
                                    : digitFormat(totalSpots ?? 0) || '00'}
                            </span>
                        </td>
                        <td align='right' style={deliverySumCellStyle}>
                            <span style={deliveryTextStyle}>
                                {!hasPlan
                                    ? ''
                                    : digitFormat((totalSpots/totalSpots)*100 ?? 0) || '00'}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default DeliverySpots;
